import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ConfirmationDialogMulti } from "../../components/DialogCollection";
import ReportList from "./reportList";
import * as PageRoutes from "../../utils/route_pages";

const ReportPage = (props) => {
  const { params, onClose } = props;
  const navigate = useNavigate();
  const { id, type } = params;
  const [isOpenReportList, setIsOpenReportList] = useState(false);
  const [isAnonymous, setIsAnonymous] = useState(false);

  return (
    <div>
      <ConfirmationDialogMulti
        title="Report"
        confirmLabel1="Yes"
        confirmLabel2="No"
        cancelLabel="Cancel"
        message={`Do you want to report this ${
          type === "feed" ? "post" : "comment"
        } as anonymous?`}
        isCustomBtn
        style={{ width: "300px" }}
        show={true}
        onCancel={() => onClose()}
        onConfrim1={() => {
          setIsOpenReportList(true);
          setIsAnonymous(true);
          navigate(
            `${PageRoutes.report}/?type=${type}&id=${id}&isAnonymous=true`
          );
        }}
        onConfrim2={() => {
          setIsOpenReportList(true);
          setIsAnonymous(false);
          navigate(
            `${PageRoutes.report}/?type=${type}&id=${id}&isAnonymous=false`
          );
        }}
      />

      {isOpenReportList ? (
        <ReportList
          params={{ id, type, isAnonymous }}
          isAnonymous={isAnonymous}
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default ReportPage;
